import minecraftBambooFarm from "../../posts/minecraft/bamboo-farm.mdx"; 
import codingQuestions from "../../posts/programming/Coding-Questions.mdx"; 
import twoSum from "../../posts/programming/Prompts/TwoSum.mdx";
import stock from "../../posts/programming/Prompts/Stock.mdx";
import duplicate from "../../posts/programming/Prompts/Duplicate.mdx";
import climbingStairs from "../../posts/programming/Prompts/ClimbStairs.mdx";
import alienDictionary from "../../posts/programming/Prompts/AlienDictionary.mdx";
import pascals from "../../posts/programming/Prompts/Pascals.mdx";
import romanToInt from "../../posts/programming/Prompts/RomantoInteger.mdx";
import mywebsite from "../../posts/misc/website.mdx";
// import loops from "../../posts/programming/Notes/loops.mdx"; 

const BlogLinks = [
    {
        id: 0,
        href: 'bamboo-farm',
        content: minecraftBambooFarm, 
    },
    {
        id: 1,
        href: 'Coding-Questions', 
        content: codingQuestions, 
    },
    {
        id: 2,
        href: 'two-sum', 
        content: twoSum, 
    },
    {
        id: 3,
        href: 'best-time-to-buy-and-sell', 
        content: stock, 
    },
    {
        id: 4,
        href: 'contains-duplicate', 
        content: duplicate, 
    },
    {
        id: 5,
        href: 'climbing-stairs', 
        content: climbingStairs, 
    },
    {
        id: 6,
        href: 'verifying-alien-dictionary', 
        content: alienDictionary, 
    },
    {
        id: 7,
        href: 'pascals-triangle', 
        content: pascals, 
    },
    {
        id: 8,
        href: 'roman-to-integer', 
        content: romanToInt, 
    },
    {
        id: 9,
        href: 'my-website', 
        content: mywebsite, 
    },
];
export default BlogLinks;